import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import how1 from "assets/img/clipboard.png";
import how2 from "assets/img/ebook.png";
import how3 from "assets/img/credit-card.png";
import how4 from "assets/img/service.png";
import rectangle4 from "../../assets/images/rectangle4.png";
import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";
import { CalendarToday, CreditCard } from "@material-ui/icons";
import { FormattedMessage, injectIntl } from "react-intl";
import jerrysplash from "assets/images/Mask Group11_new3.png";
import { connect } from "react-redux";
import { compose } from "redux";
import * as actions from "../../actions";
import { APP_NAME } from "../../utils/config/constants";
import AppLinks from "./AppLinks";
const data = [
    {
        title: "Inspection",
        heading:
            "Buying or selling a home or just need a pro to provide an inspection?",
        description:
            "When you book an inspection with ezPro, your inspection report is saved in your profile and you get an inspector that is qualified, insured, as well as our Service  guarantee.",
        src: require("../../assets/images/group.png"),
        color: "#E41C23",
    },
    {
        title: "Maintenance",
        heading:
            "Maintaining your home is key to preventing unexpected repairs and keeping your home in good working order.",
        description:
            "Our app is the one place to maintain your HVAC, roof, pest control, landscaping, water filtration systems, and everything else your home needs all in one place.",
        src: require("../../assets/images/group1.png"),
        color: "#E99C2E",
    },
    {
        title: "Repair/Replace",
        heading:
            "Something broke and needs to be either repaired or replaced? We got you covered.",
        description:
            "Gain access to a pro with just a few clicks and no phone calls needed.  Air conditioning down, book a pro ASAP.  Even for items in your home that need replacement, we can get a pro out and get you a fair estimate for your replacement project.",
        src: require("../../assets/images/group2.png"),
        color: "#0078FF",
    },
];
class AboutContent extends React.Component {
    render() {
        const { classes, banners } = this.props;

        const { formatMessage } = this.props.intl;
        return (
            <section className="Abouts">

                {/* SECTION 1 */}
                <section className="abouts3">
                    <div className="hide_class">
                        {/* <div className="custombubble1" /> */}
                        <div className="custombubble2" />
                    </div>
                    <div className="about3-heading">
                        <p className="howabout-heading">
                            What you get with ezPro:
                        </p>
                    </div>
                    <div className="container">
                        <div className="row d-flex justify-content-center">
                            {data.map((item) => {
                                return (
                                    <div className="col-sm-12 col-md-6 col-lg-4 d-flex justify-content-center">
                                        <div className="howabout-card">
                                            <img
                                                style={{
                                                    verticalAlign: "middle",
                                                    borderStyle: "none",
                                                    objectFit: "contain",
                                                    height: 85,
                                                    width: 85,
                                                }}
                                                src={item.src}
                                                alt={"img"}
                                            />

                                            <p
                                                className="howabout-subheading"
                                                style={{
                                                    color: "#000000",
                                                    marginTop: 20,
                                                    fontSize: 24,
                                                }}
                                            >
                                                {item.title}
                                            </p>
                                            <p
                                                className="howabout-text"
                                                style={{
                                                    color: item.color,
                                                }}
                                            >
                                                {item.heading}
                                            </p>
                                            <p className="howabout-text2">
                                                {item.description}
                                            </p>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </section>

                {/* SECTION 2  */}
                <section className="abo_div">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-7">
                                <p className="ab_heading">How Does it Work?</p>
                                <ul className="list-group1">
                                    <li className="list-group-item1 d-flex justify-content-between">
                                        <div className="icon_button">
                                            <p className="icon_text1">01</p>
                                        </div>
                                        <div className="list_text">
                                            <p
                                                style={{
                                                    fontFamily: "Avenir",
                                                    fontStyle: "normal",
                                                    fontWeight: "500",
                                                    fontSize: "18px",
                                                    lineHeight: "25px",
                                                    color: "#333333",
                                                }}
                                            >
                                                With just a few taps in our
                                                app/website, you can find the
                                                service you need like repairing
                                                your air conditioning.
                                            </p>
                                        </div>
                                    </li>
                                    <li className="list-group-item1 d-flex justify-content-between">
                                        <div className="icon_button">
                                            <p className="icon_text1">02</p>
                                        </div>
                                        <div className="list_text">
                                            <p
                                                style={{
                                                    fontFamily: "Avenir",
                                                    fontStyle: "normal",
                                                    fontWeight: "500",
                                                    fontSize: "18px",
                                                    lineHeight: "25px",
                                                    color: "#333333",
                                                }}
                                            >
                                                Next, schedule a date and time.
                                                Need to cancel or reschedule?
                                                Just open the app, select your
                                                booking and either reschedule or
                                                cancel with just a few taps. No
                                                excuses needed!
                                            </p>
                                        </div>
                                    </li>
                                    <li className="list-group-item1 d-flex justify-content-between">
                                        <div className="icon_button">
                                            <p className="icon_text1">03</p>
                                        </div>
                                        <div className="list_text">
                                            <p
                                                style={{
                                                    fontFamily: "Avenir",
                                                    fontStyle: "normal",
                                                    fontWeight: "500",
                                                    fontSize: "18px",
                                                    lineHeight: "25px",
                                                    color: "#333333",
                                                }}
                                            >
                                                Once a Pro confirms your job,
                                                your done and you can cross one
                                                more thing off your list.
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-5 text-center">
                                <img
                                    className="responsive-grp-img"
                                    style={{
                                        verticalAlign: "middle",
                                        borderStyle: "none",
                                        objectFit: "contain",
                                        width: '110%',
                                        height: '100%'
                                    }}
                                    src={require("../../assets/images/howabout1_new2.png")}
                                    alt={"img"}
                                />
                            </div>
                            <div className="side_img">
                                <img
                                    style={{
                                        verticalAlign: "middle",
                                        borderStyle: "none",
                                        width: "100%",
                                        height: "80%",
                                    }}
                                    src={require("../../assets/images/rectangle3.png")}
                                    alt={"img"}
                                />
                                <div className="custombubble1" />
                                <div className="custombubble2" />

                                <div className="custombubble3" />
                            </div>

                            <div
                                className="custombubble1 d-none"
                                style={{
                                    position: "absolute",
                                    bottom: 0,
                                    right: 140,
                                }}
                            />
                        </div>
                    </div>
                </section>

                {/* SECTION 3 */}
                <section className="abouts2">
                    <div className="responsive-what-else-div2">
                        <div className="container">
                            <div className="row d-flex justify-content-center">
                                <div
                                    className="col-sm-12 col-md-6"
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <img
                                        className="mobile_img"
                                        style={{
                                            verticalAlign: "middle",
                                            borderStyle: "none",
                                            objectFit: "contain",
                                            zIndex: 5,
                                        }}
                                        src={require("../../assets/images/howabout2.png")}
                                        alt={"img"}
                                    />

                                    <img
                                        className="responsive-grp-img"
                                        style={{
                                            verticalAlign: "middle",
                                            borderStyle: "none",
                                            objectFit: "contain",
                                            position: "absolute",
                                            alignSelf: "center",
                                            top: "41px",
                                        }}
                                        src={require("../../assets/images/group4.png")}
                                        alt={"img"}
                                    />
                                </div>

                                <div
                                    className="col-sm-12 col-md-6"
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    <div className="space_div">
                                        <p className="howabout-heading">
                                            Book a pro get something fixed
                                            without making a call
                                        </p>
                                        <p className="howabout-text">
                                            Calling around to contractors can
                                            not only be frustrating but time
                                            consuming. Finding a pro, checking
                                            their back ground and insurance and
                                            not to mention their reviews takes
                                            time. Then once you think you have
                                            the right one, they don't return
                                            your call or show up to do the job.
                                            <br />
                                            <br />
                                            At EzPro, we have a trusted
                                            professional network that are
                                            screened for you by us, and reviewed
                                            by you. Wouldn’t it be nice to find
                                            a pro to do your landscaping, pest
                                            control, and misc projects around
                                            your home in just a few short
                                            clicks. Everything including paying
                                            your pros is done in the app and
                                            comes with ezPro’s satisfaction
                                            guarantee.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* SECTION 4 */}
                <section className="Service-Guarantee">
                    <div className="container">
                        <div className="text-center">
                            <p className="ab_heading">Service Guarantee</p>
                        </div>
                        <div className="row">
                            <div className="col-sm-12 col-lg-12 col-xl-6">
                                <div className="service_div text-center">
                                    <img
                                        className="img-fluid"
                                        src={jerrysplash}
                                        alt="img"
                                    />
                                </div>
                            </div>
                            <div className="col-sm-12 col-lg-12 col-xl-6">
                                <div className="service_div2">
                                    <p className="service_text" style={{ paddingTop: 100 }}>
                                        Your payment is held by ezPro and not sent to the Service Pro until you accept the job, within 24 hours of completion.
                                        All services have a minimum warranty of 90 days by your Service Pro. Our
                                        services are not only directly booked
                                        with Service Pros, but also ensure the
                                        Service Pros finish the job and do the
                                        job correctly. We only ask for the
                                        opportunity to make it right by sending
                                        back the Service Pro to fix or finish
                                        the job to your expectations, if
                                        something were to go wrong.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* SECTION 5 */}
                <section>
                    <AppLinks settings={this.props.settings} />
                </section>
            </section>
        );
    }
}
const mapStateToProps = ({ settings }) => {
    return { settings: settings };
};
const composedComponent = compose(
    withStyles(productStyle),
    connect(
        mapStateToProps,
        actions
    )
);
export default composedComponent(injectIntl(AboutContent));



// WEBPACK FOOTER //
// ./src/components/About/AboutContent.js